function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "send-rotated_svg__a",
  d: "M18.446.268a.909.909 0 111.286 1.286l-10 9.999a.909.909 0 01-1.285-1.286l10-9.999zM3.373 7.374L9.46 10.08c.206.092.37.256.462.462l2.705 6.086 4.982-14.235L3.373 7.374zM8.401 11.6L.54 8.104c-.752-.334-.708-1.416.069-1.688L18.789.053a.909.909 0 011.158 1.158l-6.363 18.18c-.272.777-1.354.821-1.688.07L8.4 11.598z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 2)"
}, React.createElement("mask", {
  id: "send-rotated_svg__b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#send-rotated_svg__a"
})), React.createElement("use", {
  fill: "#000",
  fillRule: "nonzero",
  xlinkHref: "#send-rotated_svg__a"
}), React.createElement("g", {
  fill: "#000",
  mask: "url(#send-rotated_svg__b)"
}, React.createElement("path", {
  d: "M-2-2h24v24H-2z"
})));

var SvgSendRotated = function SvgSendRotated(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/send-rotated.7f0a946c.svg";
export { SvgSendRotated as ReactComponent };